import Test from '@/models/Test';
import IStateMapCreatorStrategy from './IStateMapCreatorStrategy';
import { IStateMap } from './models/IQtiSession';

class StateMapCreator implements IStateMapCreatorStrategy {
  createStateMap(test: Test): IStateMap {
    return test.toStateMapInterface();
  }
}

export default StateMapCreator;
